/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';

import { object, string, bool } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import Graphql404ErrorProducts from '../../../GraphqlSearchPage/Partials/GraphqlSearchProducts';

import { GRAPHQL_ENV } from '../../../../../gql';
import * as app from '../../../../../../state/ducks/App';
import { getBestSellersId } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useExperimentServiceAttributes from '../../../../../helpers/experimentService/useExperimentServiceAttributes';

const brandSelectors = app.ducks.brand.selectors;

const styles = (theme) => ({
    siteContainer: {
        margin: '0 15px',
        [theme.breakpoints.up(1430)]: {
            margin: '0 auto',
        },
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
            minWidth: '100%',
            margin: '0 auto',
        },
    },
});

const GraphqlProductContainer = ({
    brand, categoryCode, classes, productNotAvaliable, eventSubType,
}) => {
    const { targeting, context, isGraphqlTargetingEnabled } = useExperimentServiceAttributes({ queryName: 'findCategoryById' });
    const CATEGORY_PRODUCT_QUERY = gql`
    query CategoryProductQuery${isGraphqlTargetingEnabled ? '($targeting: [Targeting])' : ''} {
        findCategoryById(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", id: "${categoryCode}", locale: "en-us", productOptions: {page: 1}, ${isGraphqlTargetingEnabled ? 'targeting: $targeting' : ''}) {
            products {
                id
                brandId
                image {
                    additionalImages
                    altText
                    name
                    snipe
                    snipeImagePath
                    path
                    collectionImage
                }
                partNumber
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {
                        value
                    }
                    retail {
                        value
                    }
                }
                name
                brand
                seo {
                    url
                }
                availability {
                    availabilityIndicator
                    deliveryDateType
                    displayEndDate
                    displayStartDate
                    earliestShipDate
                    latestShipDate
                    perishable
                    productDeliveryType
                    shipAlone
                    deliveryMessage
                }
            }
            attributionToken
            source
            ${context?.api === 'experiments' ? 'experiments' : ''}
        }
    }
`;

    return (

        <Query query={CATEGORY_PRODUCT_QUERY} variables={isGraphqlTargetingEnabled ? { targeting } : {}} context={context}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'Graphql404ErrorProductContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'Graphql404ErrorProductContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const experiments = data?.findCategoryById?.experiments || [];
                const updatedExperiments = [...experiments];
                experiments.forEach((exp) => {
                    updatedExperiments.push({
                        ...exp,
                        source: 'vertex-ai',
                        attributionToken: data.findCategoryById?.attributionToken,
                    });
                });
                if (data && data.findCategoryById && data.findCategoryById.products) {
                    const products = data.findCategoryById.products;

                    return (
                        <Grid className={classes.siteContainer}>
                            {products && products.length ? (
                                <Graphql404ErrorProducts
                                    brand={brand}
                                    eventSubType={eventSubType}
                                    products={products}
                                    productNotAvaliable={productNotAvaliable}
                                    experiments={updatedExperiments}
                                />
                            ) : null}
                        </Grid>
                    );
                }
                return null;
            }}
        </Query>

    );
};

GraphqlProductContainer.propTypes = {
    categoryCode: string.isRequired,
    brand: object.isRequired,
    classes: object.isRequired,
    productNotAvaliable: bool,
    eventSubType: string,
};
GraphqlProductContainer.defaultProps = {
    productNotAvaliable: false,
    eventSubType: '',
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
    categoryCode: getBestSellersId(state),
});

export default connect(mapStateToProps)(withStyles(styles)(GraphqlProductContainer));
